/* =========================================================
   PTAH REVIEWS — persistent local reviews (per-browser)
   Admin mode via #admin in URL or localStorage flag.
   ========================================================= */
(function () {
  'use strict';

  const root = document.getElementById('reviews');
  if (!root) return;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const productId = root.dataset.productId || 'default';
  // v2: flushes older seeds that shipped with photo placeholders/dashes
  const STORE_KEY = 'ptah_reviews:v2:' + productId;

  /* ---------- Seed data ---------- */
  function seed() {
    return [
      { id: 'r1', name: 'Marcus T.', rating: 5, verified: true, date: '2026-05-18',
        title: 'Exactly what we needed for the event',
        body: 'Got 60 hoodies done for our company retreat. Honestly wasn\'t expecting much for the price but these are legit heavy, way heavier than the usual promo stuff. Print came out super clean and half the office asked where we ordered from. Will 100% be back.',
        photos: [],
        helpful: 34 },
      { id: 'r2', name: 'Alicia M.', rating: 5, verified: true, date: '2026-05-02',
        title: 'Chest embroidery came out 🔥',
        body: 'Did 20 pieces for my brand drop and the embroidery is honestly better than shops charging 3x more. Thread colors matched my mockup perfectly and the stitching is super tight. Zero issues.',
        photos: [],
        helpful: 28 },
      { id: 'r3', name: 'Jordan A.', rating: 4, verified: true, date: '2026-04-11',
        title: 'Quality is there, just size up if you\'re in between',
        body: 'Fabric feels premium, no complaints there. I\'m usually a true M but these run a little big in the chest, would probably go S next time for a slimmer fit. Print has held up after 5 washes so far.',
        photos: [],
        helpful: 17 },
      { id: 'r4', name: 'Ryan B.', rating: 5, verified: true, date: '2026-03-29',
        title: 'Fast turnaround on 100 pieces',
        body: 'Needed 100 zip hoodies for a client gift and they delivered 3 days early. Vinyl graphics were sharp across all sizes and the packaging was clean. My client was impressed. Sending another order next month.',
        photos: [],
        helpful: 41 },
      { id: 'r5', name: 'Sasha K.', rating: 5, verified: true, date: '2026-03-14',
        title: 'Finally found a printer that gets streetwear',
        body: 'Used a few local shops before and always got the same mid results. These guys actually get the aesthetic. The wash on the fabric is perfect out of the box and the DTF went exactly where I asked. Not cheap but worth it.',
        photos: [],
        helpful: 22 },
      { id: 'r6', name: 'Dana P.', rating: 5, verified: true, date: '2026-02-27',
        title: 'Reordered twice already',
        body: 'First order was a test, 10 tees for myself and some friends. Everyone liked them so much I went back for 30 more and then another 40 for a pop up. Quality is consistent every time which is honestly rare.',
        photos: [],
        helpful: 15 },
      { id: 'r7', name: 'Chris V.', rating: 4, verified: true, date: '2026-02-09',
        title: 'Good stuff, proof took a minute',
        body: 'Shirts came out great and the fit is solid. Took like a day to hear back on my proof which stressed me out a bit since I had a deadline. Everything still arrived on time tho. Would order again.',
        photos: [],
        helpful: 9 },
      { id: 'r8', name: 'Lena G.', rating: 5, verified: true, date: '2026-01-22',
        title: '10/10 for small orders',
        body: 'Ordered literally 2 hoodies with a custom design for my parents anniversary. Most shops won\'t even take orders that small. They treated it like a big order anyway, sent a preview and double checked the sizes. My parents wear them nonstop lol',
        photos: [],
        helpful: 13 }
    ];
  }

  /* ---------- Storage (localStorage) ---------- */
  function load() {
    try {
      const raw = localStorage.getItem(STORE_KEY);
      if (raw) return JSON.parse(raw);
    } catch {}
    const s = seed();
    save(s);
    return s;
  }
  function save(arr) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(arr)); } catch {}
  }

  function isAdmin() {
    return location.hash.indexOf('admin') > -1 || localStorage.getItem('ptah_review_admin') === '1';
  }

  let reviews = load();
  let filter = 'all';

  /* ---------- Helpers ---------- */
  function avg(arr) {
    if (!arr.length) return 0;
    return arr.reduce((s, r) => s + r.rating, 0) / arr.length;
  }
  function starsHTML(rating, size) {
    const full = Math.floor(rating);
    const rem = rating - full;
    const path = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17.8 5.9 21l1.5-6.8L2.2 9.6l6.9-.7z"/></svg>';
    let html = '<span class="stars ' + (size || '') + '">';
    for (let i = 1; i <= 5; i++) {
      if (i <= full) html += '<span class="star star--full">' + path + '</span>';
      else if (i === full + 1 && rem >= 0.5) html += '<span class="star star--full" style="opacity:0.55">' + path + '</span>';
      else html += '<span class="star">' + path + '</span>';
    }
    return html + '</span>';
  }
  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch { return iso; }
  }
  function esc(s) {
    const d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML;
  }

  /* ---------- Render ---------- */
  function render() {
    const head = $('[data-reviews-head]', root);
    const list = $('[data-reviews-list]', root);
    if (!head || !list) return;

    const a = avg(reviews);
    const n = reviews.length;
    const dist = [5, 4, 3, 2, 1].map(s => {
      const c = reviews.filter(r => Math.round(r.rating) === s).length;
      return { star: s, c, pct: n ? Math.round(c / n * 100) : 0 };
    });
    head.innerHTML =
      '<div>' +
        '<div class="reviews__score-num">' + a.toFixed(1) + '</div>' +
        '<div class="reviews__score-stars">' + starsHTML(a, 'stars--lg') + '</div>' +
        '<div class="reviews__score-count">' + n + ' review' + (n !== 1 ? 's' : '') + '</div>' +
      '</div>' +
      '<div class="reviews__bars">' +
        dist.map(d =>
          '<div class="reviews__bar">' +
            '<span class="reviews__bar-label">' + d.star + ' ★</span>' +
            // width is set inline at render time — the old rAF-driven
            // animation never fired in throttled/background tabs and the
            // bars stayed empty grey tracks
            '<span class="reviews__bar-track"><span class="reviews__bar-fill" style="width:' + d.pct + '%"></span></span>' +
            '<span class="reviews__bar-pct">' + d.pct + '%</span>' +
          '</div>'
        ).join('') +
      '</div>';

    // List
    let shown = reviews.slice();
    if (filter === 'photos') shown = shown.filter(r => r.photos && r.photos.length);
    else if (filter === '5') shown = shown.filter(r => Math.round(r.rating) === 5);
    else if (filter === 'critical') shown = shown.filter(r => r.rating <= 3);

    const admin = isAdmin();
    if (!shown.length) {
      list.innerHTML = '<p class="t-small text-center" style="padding:48px 0;color:var(--ink-3)">No reviews match this filter yet.</p>';
    } else {
      list.innerHTML = shown.map(r =>
        '<div class="review">' +
          '<div class="review__head">' +
            '<div class="review__author">' +
              '<span class="review__name">' + esc(r.name) +
                (r.verified ? '<span class="review__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 4 4 10-10" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified buyer</span>' : '') +
                (r.featured ? '<span class="review__featured">Featured</span>' : '') +
              '</span>' +
            '</div>' +
            '<div style="text-align:right;display:flex;flex-direction:column;gap:6px;align-items:flex-end">' +
              starsHTML(r.rating, '') +
              '<span class="review__date">' + fmtDate(r.date) + '</span>' +
            '</div>' +
          '</div>' +
          (r.title ? '<div class="review__title">' + esc(r.title) + '</div>' : '') +
          '<div class="review__body">' + esc(r.body) + '</div>' +
          '<div class="review__helpful">' +
            '<button data-helpful="' + r.id + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M7 11v9m0-9 3-8a2 2 0 0 1 4 1v4h5a2 2 0 0 1 2 2.4l-1.5 6A2 2 0 0 1 17.5 22H7" stroke-linecap="round" stroke-linejoin="round"/></svg>Helpful (' + (r.helpful || 0) + ')</button>' +
            (admin ? '<button data-delete="' + r.id + '" style="color:var(--error);border-color:var(--error)">Delete</button>' : '') +
          '</div>' +
        '</div>'
      ).join('');
    }

    // bind events
    $$('[data-helpful]', list).forEach(b => {
      b.addEventListener('click', () => {
        const id = b.dataset.helpful;
        const r = reviews.find(x => x.id === id);
        if (r) { r.helpful = (r.helpful || 0) + 1; save(reviews); render(); }
      });
    });
    $$('[data-delete]', list).forEach(b => {
      b.addEventListener('click', () => {
        if (!confirm('Delete this review?')) return;
        reviews = reviews.filter(x => x.id !== b.dataset.delete);
        save(reviews); render();
      });
    });

    // Sync inline rating
    const inline = $('[data-pdp-rating]');
    if (inline) {
      inline.innerHTML = starsHTML(a, '') + '<span style="color:var(--ink-3)">' + a.toFixed(1) + ' · ' + n + ' reviews</span>';
      inline.style.cursor = 'pointer';
    }
  }

  /* ---------- Lightbox ---------- */
  function openLightbox(src) {
    let lb = $('#review-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'review-lightbox';
      lb.className = 'lightbox';
      lb.innerHTML = '<button class="lightbox__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="20" height="20"><path d="M6 6 L18 18 M18 6 L6 18" stroke-linecap="round"/></svg></button><img alt="">';
      document.body.appendChild(lb);
      lb.addEventListener('click', e => {
        if (e.target === lb || e.target.closest('.lightbox__close')) {
          lb.classList.remove('is-open');
          document.body.classList.remove('no-scroll');
        }
      });
    }
    lb.querySelector('img').src = src;
    lb.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }

  /* ---------- Filters ---------- */
  $$('[data-review-filter]', root).forEach(c => {
    c.addEventListener('click', () => {
      $$('[data-review-filter]', root).forEach(x => x.classList.remove('is-active'));
      c.classList.add('is-active');
      filter = c.dataset.reviewFilter;
      render();
    });
  });

  /* ---------- Submission form ---------- */
  const form = $('[data-review-form]', root);
  if (form) {
    let rating = 5;
    let photoData = [];

    const starBtns = $$('.star-input button', form);
    starBtns.forEach((b, i) => {
      b.addEventListener('mouseenter', () => starBtns.forEach((x, j) => x.classList.toggle('is-hover', j <= i)));
      b.addEventListener('mouseleave', () => starBtns.forEach(x => x.classList.remove('is-hover')));
      b.addEventListener('click', () => {
        rating = i + 1;
        starBtns.forEach((x, j) => x.classList.toggle('is-active', j <= i));
      });
    });
    starBtns.forEach((b, j) => b.classList.toggle('is-active', j < 5));

    const photoInput = $('[data-review-photo]', form);
    const photoPreview = $('[data-review-photo-preview]', form);
    if (photoInput) {
      photoInput.addEventListener('change', e => {
        photoData = [];
        if (photoPreview) photoPreview.innerHTML = '';
        Array.from(e.target.files).slice(0, 3).forEach(file => {
          const reader = new FileReader();
          reader.onload = ev => {
            photoData.push(ev.target.result);
            if (photoPreview) {
              const img = document.createElement('img');
              img.src = ev.target.result;
              img.className = 'review__photo';
              photoPreview.appendChild(img);
            }
          };
          reader.readAsDataURL(file);
        });
      });
    }

    form.addEventListener('submit', e => {
      e.preventDefault();
      const fd = new FormData(form);
      const admin = isAdmin();
      const review = {
        id: 'r_' + Date.now().toString(36),
        name: (fd.get('name') || 'Anonymous').toString().trim(),
        rating,
        verified: admin,
        featured: admin && fd.get('featured') === 'on',
        date: new Date().toISOString().slice(0, 10),
        title: (fd.get('title') || '').toString().trim(),
        body: (fd.get('body') || '').toString().trim(),
        photos: photoData.slice(),
        helpful: 0
      };
      if (!review.body) { alert('Please write a few words about the product.'); return; }
      reviews.unshift(review);
      save(reviews);
      form.reset();
      photoData = [];
      if (photoPreview) photoPreview.innerHTML = '';
      starBtns.forEach((x, j) => x.classList.toggle('is-active', j < 5));
      rating = 5;
      const wrap = $('[data-review-form-wrap]', root);
      if (wrap) wrap.classList.remove('is-open');
      render();
      if (window.PTAH_toast) window.PTAH_toast('Thanks — your review is live');
    });

    $$('[data-review-form-toggle]', root).forEach(b => {
      b.addEventListener('click', () => {
        const wrap = $('[data-review-form-wrap]', root);
        if (wrap) {
          wrap.classList.toggle('is-open');
          if (wrap.classList.contains('is-open')) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  /* ---------- Admin toggle ---------- */
  function syncAdmin() {
    const on = isAdmin();
    $$('[data-admin-only]').forEach(el => { el.style.display = on ? '' : 'none'; });
  }
  const adminBtn = $('[data-review-admin-toggle]', root);
  if (adminBtn) {
    adminBtn.textContent = isAdmin() ? 'Disable admin mode' : 'Enable admin mode';
    adminBtn.addEventListener('click', () => {
      const on = localStorage.getItem('ptah_review_admin') === '1';
      localStorage.setItem('ptah_review_admin', on ? '0' : '1');
      adminBtn.textContent = on ? 'Enable admin mode' : 'Disable admin mode';
      syncAdmin();
      render();
    });
  }
  window.addEventListener('hashchange', () => { syncAdmin(); render(); });
  syncAdmin();
  render();
})();
